import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const loadPlayers = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('players.loadPlayers'));
    const defaultReposne = {status:'error', payload: {code: '', owner:null, players: []}};
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/table/players/' + tableId);
        Store.dispatch(loadingActions.loadingEnd('players.loadPlayers'));
        return resp && resp.data ? resp.data.payload : defaultReposne;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('players.loadPlayers'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};


export const addPlayers = async (tableId, playerEmail) => {
    Store.dispatch(loadingActions.loadingStart('players.addPlayers'));
    const defaultReposne = {status:'error', payload: {name:null, color: null}};
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/invite/' + tableId, {
            email: playerEmail
        });
        Store.dispatch(loadingActions.loadingEnd('players.addPlayers'));
        return resp && resp.data ? resp.data.payload : defaultReposne;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('players.addPlayers'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};


export const removePlayers = async (tableId, playerId) => {
    Store.dispatch(loadingActions.loadingStart('players.removePlayers'));
    const defaultReposne = [];
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/' + tableId + '/revoke/' + playerId, {});
        Store.dispatch(loadingActions.loadingEnd('players.removePlayers'));
        return resp && resp.data ? resp.data.payload : defaultReposne;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('players.removePlayers'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

export const getAwaitingPlayers = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('players.getAwaitingPlayers'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/table/' + tableId + '/awaiting');
        Store.dispatch(loadingActions.loadingEnd('players.getAwaitingPlayers'));
        return resp && resp.data ? resp.data : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('players.getAwaitingPlayers'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};

export const allowAwaitingPlayer = async (tableId, playerId) => {
    Store.dispatch(loadingActions.loadingStart('players.allowAwaitingPlayer'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/' + tableId + '/allowawaiting', {playerId});
        Store.dispatch(loadingActions.loadingEnd('players.allowAwaitingPlayer'));
        return resp && resp.data ? resp.data : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('players.allowAwaitingPlayer'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};

export const denyAwaitingPlayer = async (tableId, playerId) => {
    Store.dispatch(loadingActions.loadingStart('players.denyAwaitingPlayer'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/' + tableId + '/denyawaiting', {playerId});
        Store.dispatch(loadingActions.loadingEnd('players.denyAwaitingPlayer'));
        return resp && resp.data ? resp.data : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('players.denyAwaitingPlayer'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};
